export const BARLOW_FONT = 'Barlow Semi Condensed Semibold';
export const FIGTREE_FONT = 'Figtree';
